@for (item of field.fieldGroup; track item; let i = $index) {
  <div class="repeat-section-item-wrapper">
    <div class="repeat-section-header">{{ header }}</div>
    @if (props['subheader']) {
      <div class="repeat-section-subheader">{{ props['subheader'] }}</div>
    }

    @if (isSaved(item)) {
      <div class="rkt-form-repeat-section-item address-card">
        @if (isPrimaryShown(i)) {
          <span class="address-primary-badge">Primary</span>
        }
        @for (line of lines(item); track $index) {
          <div class="address-card-line">{{ line }}</div>
        }
        <div class="address-card-actions">
          @if (!item.model?.verified) {
            <button
              type="button"
              class="address-card-action address-card-edit"
              title="Edit"
              [attr.aria-label]="actionLabel('Edit', item)"
              (click)="edit(i)"
            >
              <rkt-icon name="edit-outline" />
            </button>
          }
          @if (canDelete()) {
            <button
              type="button"
              class="address-card-action"
              title="Delete"
              [attr.aria-label]="actionLabel('Delete', item)"
              (click)="delete(i)"
            >
              <rkt-icon name="trash-outline" />
            </button>
          }
        </div>
      </div>
    } @else {
      <div class="rkt-form-repeat-section-item">
        @if (showPicker(item)) {
          <div class="address-picker">
            <div class="rkt-form-field" [class.has-error]="hasPickerError(item)">
              <div class="rkt-form-label">
                <label [attr.for]="pickerId(i)">{{ props['pickerLabel'] }}<span class="asterisk" aria-hidden="true">*</span></label>
              </div>
              <ng-select
                class="rkt-form-select"
                [class.is-invalid]="hasPickerError(item)"
                [labelForId]="pickerId(i)"
                [items]="pickerOptions(item)"
                bindLabel="line1"
                bindValue="key"
                [ngModel]="pickedKey(item)"
                [ngModelOptions]="{ standalone: true }"
                required
                [clearable]="false"
                [searchable]="false"
                placeholder="Select"
                (change)="pick(item, $event)"
              >
                <ng-template ng-option-tmp let-option="item">
                  @if (option.key === newAddressKey) {
                    <span class="address-picker-new"><rkt-icon name="plus" /> {{ option.line1 }}</span>
                  } @else {
                    <span class="address-picker-line1">{{ option.line1 }}</span>
                    <span class="address-picker-line2">{{ option.line2 }}</span>
                  }
                </ng-template>
              </ng-select>
              @if (hasPickerError(item)) {
                <div class="rkt-form-field-invalid-feedback" role="alert">{{ props['pickerLabel'] }} is required</div>
              }
            </div>
          </div>
        } @else {
          <formly-field class="rkt-form-row-group" [field]="item" />
        }
        <div class="address-form-actions">
          <label class="address-primary-toggle">
            <input
              type="checkbox"
              [checked]="isPrimaryChecked(item, i)"
              [disabled]="isPrimary(i)"
              (change)="togglePrimary(item, $any($event.target).checked)"
            />
            Set as primary
          </label>
          @if (canCancel(item, i)) {
            <button rktButton btnType="secondary" type="button" (click)="cancel(i)">Cancel</button>
          }
          <button rktButton type="button" (click)="save(i)">Save</button>
        </div>
      </div>
    }
  </div>
}
<button type="button" class="repeat-section-add-btn" (click)="addAddress()">
  <rkt-icon name="plus" class="add-icon" /> {{ props['addText'] }}
</button>
